import React from 'react';
import './MySignals.scss';
import { useAuth } from '../../../../commons/Auth';
import SignalsPresentational from './SignalsPresentational';

const SignalsSpecialJobs = ({
  profile,
  query,
  total,
  signals,
  onFilter,
  selectedSignals,
  onSelectAll,
  onRowClick,
  onInvoice,
  selectedAll,
  onStatusChanged,
}) => {
  const [{ newToken, newIsAdmin } = {}] = useAuth();

  return (
    <SignalsPresentational
      data={signals}
      profile={profile}
      newIsAdmin={newIsAdmin}
      query={query}
      total={total}
      onFilter={onFilter}
      selectedSignals={selectedSignals}
      onSelectAll={onSelectAll}
      onRowClick={onRowClick}
      onInvoice={onInvoice}
      selectedAll={selectedAll}
      onStatusChanged={onStatusChanged}
    />
  );
};

export default SignalsSpecialJobs;
